import { ADVISOR_ROLLOVER_DATA_RECEIVED, ADVISOR_ROLLOVER_DATA_UNLOADED } from './types';

export default function rollover(state = [], action = {}){
  switch (action.type) {
    case ADVISOR_ROLLOVER_DATA_RECEIVED:
      return action.data
    case ADVISOR_ROLLOVER_DATA_UNLOADED:
      return []
    default:
      return state;
  }
}
